/* eslint-disable import/prefer-default-export */
import { useMemo } from 'react';
import { useCompanies } from '../useCompanies';
import { useLoggedInUser } from '../useLoggedInUser';

export const useUpdateUserModal = () => {
  const { allCompanies } = useCompanies();

  const { hasUserPermissionToChange: userRolePermission } = useLoggedInUser();

  const hasUserPermissionToChange = useMemo(() => {
    return !!(userRolePermission && allCompanies.length);
  }, [userRolePermission, allCompanies]);

  return {
    hasUserPermissionToChange,
  };
};
